import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Big } from 'foundations-components/transitional/components/Big';
import { H5 } from 'foundations-components/transitional/components/H5';
import { getNewSnippetsUrl } from '../../lib/links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SnippetPopoverEmptyState = () => /*#__PURE__*/_jsxs(TFlex, {
  direction: "column",
  align: "center",
  marginBlockStart: "1000",
  children: [/*#__PURE__*/_jsx(Illustration, {
    name: "text-snippet",
    marginBlockEnd: "300"
  }), /*#__PURE__*/_jsx(H5, {
    marginBlockEnd: "500",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'RichTextLib.snippet.empty.title'
    })
  }), /*#__PURE__*/_jsx(Big, {
    marginBlockEnd: "500",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'RichTextLib.snippet.empty.description'
    })
  }), /*#__PURE__*/_jsx(Button, {
    use: "tertiary",
    external: true,
    href: getNewSnippetsUrl(),
    size: "small",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'RichTextLib.snippet.button.createFirst'
    })
  })]
});
export default SnippetPopoverEmptyState;